/**
 * One expandable category group in the left nav. Parent label + caret; children are checkboxes (subcategories).
 */
import React, { useState } from "react";

export default function MListSidebarCategoryGroup({ grouping, selectedTagIds, onTagIdsChange }) {
  const [expanded, setExpanded] = useState(true);
  const tags = grouping?.tags ?? [];
  const name = grouping?.name ?? grouping?.title ?? "Category";

  const toggleTag = (tagId) => {
    if (tagId == null) return;
    const next = selectedTagIds.includes(tagId)
      ? selectedTagIds.filter((x) => x !== tagId)
      : [...selectedTagIds, tagId];
    onTagIdsChange(next);
  };

  return (
    <div className="twentytwentysix-content__mlist-sidebar-group">
      <button
        type="button"
        className="twentytwentysix-content__mlist-sidebar-group-head"
        onClick={() => setExpanded((e) => !e)}
        aria-expanded={expanded}
        aria-controls={`mlist-cat-${grouping?.id ?? name}`}
      >
        <span className="twentytwentysix-content__mlist-sidebar-group-caret">{expanded ? "▼" : "▶"}</span>
        <span>{name}</span>
      </button>
      <div id={`mlist-cat-${grouping?.id ?? name}`} className="twentytwentysix-content__mlist-sidebar-group-body" hidden={!expanded}>
        {tags.map((tag) => {
          const tagId = tag?.id ?? tag;
          const tagName = typeof tag === "object" ? (tag.name ?? tag.slug ?? tagId) : tag;
          const checked = selectedTagIds.includes(tagId);
          return (
            <label key={tagId} className="twentytwentysix-content__mlist-sidebar-check">
              <input type="checkbox" checked={checked} onChange={() => toggleTag(tagId)} aria-label={tagName} />
              <span>{tagName}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
